import { ItemIDs } from '../../Config/Items';
import * as fromActions from '../Actions/Actions';
import { ActionTypes } from '../Actions/Actions';
export interface IStatePause {
    userPaused: boolean;
    paused: boolean;
    inputPaused: boolean;
    animationsPaused: boolean;
}
export const defaultStatePause: IStatePause = {
    userPaused: false,
    paused: false,
    inputPaused: false,
    animationsPaused: false,
};
export const StatePause = (state = defaultStatePause, action: fromActions.Actions): IStatePause => {
    switch (action.type) {
        case ActionTypes.ACTIVATE_BOOSTER:
            const paused =
                state.userPaused || ![ItemIDs.HIGHLIGHT, ItemIDs.HINT].includes(action.payload);
            return {
                ...state,
                paused,
            };
        case ActionTypes.SHOW_BOOSTER:
            return {
                ...state,
                paused: action.payload !== ItemIDs.MAGNET,
            };
        case ActionTypes.BOOSTER_ACTION_COMPLETE:
            return {
                ...state,
                paused: state.userPaused || action.payload,
            };
        case ActionTypes.PAUSE_MENU_VISIBLE:
            return {
                ...state,
                paused: action.payload,
                inputPaused: action.payload,
                userPaused: action.payload,
            };
        case ActionTypes.CHANGE_VIEW:
            return {
                ...state,
                paused: false,
                inputPaused: false,
                userPaused: false,
            };
        case ActionTypes.LEVEL_STUCK:
            return {
                ...state,
                paused: state.userPaused || action.payload.stuck,
            };
        case ActionTypes.BOARD_READY:
            return {
                ...state,
                paused: state.userPaused || false,
            };
        case ActionTypes.START_LEVEL:
            return {
                ...state,
                inputPaused: false,
                paused: false,
                userPaused: false,
            };
        case ActionTypes.COMPLETE_LEVEL:
        case ActionTypes.LEVEL_COMPLETE:
            return {
                ...state,
                inputPaused: true,
            };
        case ActionTypes.POPUP_SHOWN:
            return {
                ...state,
                paused: true,
            };
        case ActionTypes.POPUP_DISMISSED:
            return {
                ...state,
                paused: state.userPaused || action.payload,
            };
        case ActionTypes.TUTORIAL_ADVANCE:
            return {
                ...state,
                paused: state.userPaused || false,
            };
        case ActionTypes.TUTORIAL_WAIT:
            return {
                ...state,
                paused: true,
            };
        case ActionTypes.ASK_FRIEND_START:
            return {
                ...state,
                paused: true,
            };
        case ActionTypes.ASK_FRIEND_COMPLETE:
            return {
                ...state,
                paused: state.userPaused || false,
            };
        default:
            return state;
    }
};
